import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Welcome from './pages/Welcome'
import Dashboard from './pages/Dashboard'
import Projects from './pages/Projects'
import Invoices from './pages/Invoices'
import CreditNotes from './pages/CreditNotes'
import Expenses from './pages/Expenses'
import Clients from './pages/Clients'
import ExpenseForm from './pages/ExpenseForm'
import ProjectExpenseForm from './pages/ProjectExpenseForm'
import AttendanceForm from './pages/AttendanceForm'
import Employees from './pages/Employees'
import Payroll from './pages/Payroll'
import Quotations from './pages/Quotations'
import PurchaseOrders from './pages/PurchaseOrders'
import Settings from './pages/Settings'
import Assets from './pages/Assets'
import Liabilities from './pages/Liabilities'
import JournalEntries from './pages/JournalEntries'
import Banking from './pages/Banking'
import BankStatement from './pages/BankStatement'
import AccountTransactions from './pages/AccountTransactions'
import Reconciliation from './pages/Reconciliation'
import { ThemeProvider } from './context/ThemeContext'
import { TemplatePreviewProvider } from './context/TemplatePreviewContext'

function App() {
  return (
    <ThemeProvider>
      <TemplatePreviewProvider>
        <AuthProvider>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <Routes>
              <Route path="/" element={<Welcome />} />
              <Route path="/login" element={<Login />} />
              <Route path="/expense-form-receipt" element={<ExpenseForm />} />
              <Route path="/expense-form-advanced" element={<ExpenseForm />} />
              <Route path="/expense-form-project" element={<ProjectExpenseForm />} />
              <Route path="/timesheet-form" element={<AttendanceForm />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/invoices" element={<Invoices />} />
                <Route path="/credit-notes" element={<CreditNotes />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/employees" element={<Employees />} />
                <Route path="/payroll" element={<Payroll />} />
                <Route path="/quotations" element={<Quotations />} />
                <Route path="/purchase-orders" element={<PurchaseOrders />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/assets" element={<Assets />} />
                <Route path="/liabilities" element={<Liabilities />} />
                <Route path="/journal-entries" element={<JournalEntries />} />
                <Route path="/banking" element={<Banking />}>
                  <Route path="bank-statement" element={<BankStatement />} />
                  <Route path="account-transactions" element={<AccountTransactions />} />
                  <Route path="reconciliation" element={<Reconciliation />} />
                </Route>
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </TemplatePreviewProvider>
    </ThemeProvider>
  )
}

export default App
